import { useState } from "react";
import CnpjUtils from "../../../shared/utils/CnpjUtils";
import { throwResponseError } from "../../utils/api-error-utils";
import { getAuthParams } from "../../utils/pacto-rebates-utils";
import { formatDashboardCycleResponse } from "../utils/dashboard-cycle-response-utils";

export function useDashboardContractCycle() {
	const [dashboardCycle, setDashboardCycle] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchDashboardCycle = async ({
		document,
		contractId,
		cycle,
		calculationMode
	}) => {
		const cleanDocument = CnpjUtils.cleanAlphanumericCnpj(document || "");

		if (!cleanDocument || !contractId || !cycle) {
			const message = "Informe o documento do cliente, o contrato e o ciclo.";

			setDashboardCycle(null);
			setError(message);

			return {
				ok: false,
				error: message
			};
		}

		try {
			setLoading(true);
			setError(null);

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const params = new URLSearchParams();

			if (calculationMode) {
				params.append("modoCalculo", calculationMode);
			}

			const queryString = params.toString();
			const encodedCycle = encodeURIComponent(cycle);

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
				`pacto-rebates-dashboard/v1/dashboard/clientes/${cleanDocument}/contratos/${contractId}/ciclos/${encodedCycle}` +
				(queryString ? `?${queryString}` : ""),
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					}
				}
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível carregar o dashboard do ciclo."
				);
			}

			const data = await response.json();
			const formattedDashboardCycle = formatDashboardCycleResponse(data);

			setDashboardCycle(formattedDashboardCycle);
			setError(null);

			return {
				ok: true,
				dashboardCycle: formattedDashboardCycle
			};
		} catch (requestError) {
			const errorMessage =
				requestError.message ||
				"Não foi possível carregar o dashboard do ciclo.";

			setDashboardCycle(null);
			setError(errorMessage);

			return {
				ok: false,
				error: errorMessage
			};
		} finally {
			setLoading(false);
		}
	};

	const clearDashboardCycle = () => {
		setDashboardCycle(null);
		setError(null);
	};

	return {
		dashboardCycle,
		dashboardCycleLoading: loading,
		dashboardCycleError: error,
		fetchDashboardCycle,
		clearDashboardCycle
	};
}